"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.es = void 0;
const es = {
  add: 'Añadir',
  remove: 'Quitar',
  error: {
    _: 'Error',
    type: 'Valor incorrecto, esperando __type__',
    min: 'El valor debe ser superior a __min__',
    max: 'El valor debe ser inferior a __max__',
    minLength: 'El valor debe tener como mínimo __minLength__ caracteres',
    maxLength: 'El valor debe tener como máximo __maxLength__ caracteres',
    required: 'Requerido',
    minChildren: 'Se esperan __minChildren__',
    maxChildren: 'Sólo puede haber __maxChildren__'
  }
};
exports.es = es;